import App, { store } from './AppContainer';

export { store };
export default App;
